/**
 * Compact 1-2-3 stepper for the registration flow.
 *
 * <Stepper currentStep={1} steps={['Child', 'Family', 'Review']} />
 */
import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { FiCheck } from "react-icons/fi";
import "./Stepper.css";

export function Stepper({ steps, currentStep = 0, className = "" }) {
    const safeSteps = Array.isArray(steps) ? steps : [];
    return (
        <Stack
            direction="row"
            spacing={0}
            className={`pt-stepper ${className}`}
            role="list"
            aria-label="Progress"
        >
            {safeSteps.map((label, i) => {
                const isCompleted = i < currentStep;
                const isCurrent = i === currentStep;
                return (
                    <React.Fragment key={label}>
                        <Box
                            className={`pt-stepper__step ${isCompleted ? "is-completed" : ""} ${
                                isCurrent ? "is-current" : ""
                            }`}
                            role="listitem"
                            aria-current={isCurrent ? "step" : undefined}
                        >
                            <Box className="pt-stepper__circle">
                                {isCompleted ? <FiCheck size={14} /> : i + 1}
                            </Box>
                            <Typography variant="caption" sx={{ fontWeight: 600 }}>
                                {label}
                            </Typography>
                        </Box>
                        {i < safeSteps.length - 1 && (
                            <Box
                                className={`pt-stepper__line ${
                                    i < currentStep ? "is-completed" : ""
                                }`}
                                aria-hidden="true"
                            />
                        )}
                    </React.Fragment>
                );
            })}
        </Stack>
    );
}

export default Stepper;
